/**
* @Description 文件功能说明：参数配置组件
* @Author CC
* @Time 2020/6/4
**/

/* HTML */
<template>
    <div class="view-tree-table">
        <!-- router-title-box start -->
		<div class="router-title-box" >
			<div class="router-title-item">
				<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">
					<span style="position: absolute;">&gt;&ensp;系统设置&ensp;&gt;&ensp;参数配置</span>
				</div>
			</div>
		</div>
		<!-- router-title-box end -->
		
		<ParamConfig ref="paramConfig"/>
    </div>
</template>

/* JS */
<script>
    import ParamConfig from "@/components_pages/System/ParamConfig";
    
    export default {
        /*
         * 组件名
         */
        name: "ParamC",
        /**
         * 数据定义
         */
        data() {
            return {
            }
        },
        /**
         * 引用组件
         * */
        components: {
            // 系统参数配置
            ParamConfig,
        },
        /**
         * 初始化创建
         */
        created() {
        },
        mounted(){
        },
        /**
         * 监听
         */
        watch: {
        },
        /**
         * 计算
         */
        computed: {
        },
        /**
         * 方法定义
         */
        methods: {
            /**
             * @Des 关闭路由
             * @Auth
             * @Date
             */
            closeRouter () {
                // 跳转到 首页
                this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
            },// closeRouter
            
        },// methods
        
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/views/system-manager/system/ParamC.vue